module.exports = "/_next/static/images/image6-e181f0a65428a8290abcdc55600cb8fd.png";